import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Deposit Reward Settings</h4>
    </div>
  );
};
